import { useLocation } from "wouter"
import { AlertTriangle } from "lucide-react"
import type { CockpitChannelAlert } from "@shared/dashboard"

// Renders only when a channel is actually broken. No permanent "connected channels"
// chips on the Cockpit — those live under Setup.

function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? ""
  return `${names.slice(0, -1).join(", ")} und ${names[names.length - 1]}`
}

export function ChannelAlert({ alert }: { alert: CockpitChannelAlert }) {
  const [, setLocation] = useLocation()
  const affected =
    alert.affectedScheduled === 0
      ? null
      : alert.affectedScheduled === 1
        ? "Ein geplanter Beitrag wartet."
        : `${alert.affectedScheduled} geplante Beiträge warten.`

  const text =
    alert.kind === "profile_error"
      ? "Die Verbindung zu Ihrem Veröffentlichungsprofil ist gestört."
      : alert.platforms.length === 1
        ? `${alert.platforms[0]} ist getrennt.`
        : `${joinNames(alert.platforms)} sind getrennt.`

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-300/70 bg-amber-50 px-4 py-2.5 text-[13px] text-foreground dark:border-amber-900/60 dark:bg-amber-950/40"
      data-testid="cockpit-channel-alert"
    >
      <AlertTriangle className="h-4 w-4 flex-none text-amber-600 dark:text-amber-400" aria-hidden="true" />
      <span>
        {text}
        {affected && <> {affected}</>}
      </span>
      <button
        type="button"
        onClick={() => setLocation(alert.href)}
        className="ml-auto rounded-full border border-amber-600 px-3 py-1 text-xs font-semibold text-amber-800 transition-colors hover:bg-amber-100 dark:border-amber-500 dark:text-amber-200 dark:hover:bg-amber-900/50"
        data-testid="button-channel-reconnect"
      >
        {alert.kind === "profile_error" ? "Prüfen" : "Neu verbinden"}
      </button>
    </div>
  )
}
